import {Container} from "./Container"
import {CodeBox} from "./CodeBox"

export const GenerateCodeStyles = {
    Container: Container,
    CodeBox: CodeBox
}